export default __webpack_public_path__ + "static/media/bg_4.fa711139.jpg";